import { render, staticRenderFns } from "./vipCard.vue?vue&type=template&id=08c7a247&scoped=true"
import script from "./vipCard.vue?vue&type=script&lang=js"
export * from "./vipCard.vue?vue&type=script&lang=js"
import style0 from "./vipCard.vue?vue&type=style&index=0&id=08c7a247&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7a247",
  null
  
)

export default component.exports